import React, { useEffect, useState } from 'react';
import { Grid } from '@nextiva/next-ui-components';

import { EDIT_ROLE, CLONE_ROLE, CREATE_ROLE } from 'constants/drawerTitles';

import { convertCrud } from '../../utils/crud';
import { CrudSelect } from '../CrudSelect';

const CrudForm = ({ toggles, onCrudFormChange, parent, drawerTitle }) => {
  const [viewValue, setViewValue] = useState();
  const [editValue, setEditValue] = useState();
  const [deleteValue, setDeleteValue] = useState();
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (parent) setDisabled(false);
    else setDisabled(true);
    if (
      drawerTitle !== EDIT_ROLE &&
      drawerTitle !== CLONE_ROLE &&
      drawerTitle !== CREATE_ROLE
    ) {
      setDisabled(true);
    }
    setViewValue(convertCrud(toggles[0]));
    setEditValue(convertCrud(toggles[1]));
    setDeleteValue(convertCrud(toggles[2]));
  }, [toggles, parent]);

  const handleViewChange = (e) => {
    const { value } = e.target;

    setViewValue(value);
    onCrudFormChange([
      convertCrud(value),
      convertCrud(editValue),
      convertCrud(deleteValue),
    ]);
  };

  const handleEditChange = (e) => {
    const { value } = e.target;

    setEditValue(value);
    onCrudFormChange([
      convertCrud(viewValue),
      convertCrud(value),
      convertCrud(deleteValue),
    ]);
  };

  const handleDeleteChange = (e) => {
    const { value } = e.target;

    setDeleteValue(value);
    onCrudFormChange([
      convertCrud(viewValue),
      convertCrud(editValue),
      convertCrud(value),
    ]);
  };

  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className="m-role-form__role-child"
        data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-RoleChild"
      >
        <Grid
          item
          data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-View"
        >
          View
        </Grid>
        <Grid item>
          <CrudSelect
            onChange={handleViewChange}
            value={viewValue}
            disabled={disabled}
            data-testid="PlatformAdminUI-RolesAndPermissions-RoleForm-View"
          />
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className="m-role-form__role-child"
        data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-RoleChild"
      >
        <Grid
          item
          data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-AddAndEdit"
        >
          Add and edit
        </Grid>
        <Grid item>
          <CrudSelect
            onChange={handleEditChange}
            value={editValue}
            disabled={disabled}
            data-testid="PlatformAdminUI-RolesAndPermissions-RoleForm-Add"
          />
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        className="m-role-form__role-child"
        data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-RoleChild"
      >
        <Grid
          item
          data-testid="PlatformAdminUI-RolesAndPermissions-CrudForm-Delete"
        >
          Delete
        </Grid>
        <Grid item>
          <CrudSelect
            onChange={handleDeleteChange}
            value={deleteValue}
            disabled={disabled}
            data-testid="PlatformAdminUI-RolesAndPermissions-RoleForm-Delete"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CrudForm;
